export default "__VITE_ASSET__baaa08bb__"